// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    gammaPublicGetStatus (params?: {}): Promise<string>;
    gammaPublicGetComments (params?: {}): Promise<List>;
    gammaPublicGetCommentsId (params?: {}): Promise<List>;
    gammaPublicGetCommentsUserAddressUserAddress (params?: {}): Promise<List>;
    gammaPublicGetEvents (params?: {}): Promise<List>;
    gammaPublicGetEventsCreators (params?: {}): Promise<List>;
    gammaPublicGetEventsCreatorsId (params?: {}): Promise<Dict>;
    gammaPublicGetEventsKeyset (params?: {}): Promise<Dict>;
    gammaPublicGetEventsPagination (params?: {}): Promise<Dict>;
    gammaPublicGetEventsResults (params?: {}): Promise<List>;
    gammaPublicGetEventsSlugSlug (params?: {}): Promise<Dict>;
    gammaPublicGetEventsId (params?: {}): Promise<Dict>;
    gammaPublicGetEventsIdCommentsCount (params?: {}): Promise<Dict>;
    gammaPublicGetEventsIdTags (params?: {}): Promise<List>;
    gammaPublicGetEventsIdTweetCount (params?: {}): Promise<Dict>;
    gammaPublicGetMarkets (params?: {}): Promise<List>;
    gammaPublicGetMarketsKeyset (params?: {}): Promise<Dict>;
    gammaPublicGetMarketsSlugSlug (params?: {}): Promise<Dict>;
    gammaPublicGetMarketsId (params?: {}): Promise<Dict>;
    gammaPublicGetMarketsIdDescription (params?: {}): Promise<Dict>;
    gammaPublicGetMarketsIdTags (params?: {}): Promise<List>;
    gammaPublicGetProfilesUserAddressUserAddress (params?: {}): Promise<Dict>;
    gammaPublicGetPublicProfile (params?: {}): Promise<Dict>;
    gammaPublicGetPublicSearch (params?: {}): Promise<Dict>;
    gammaPublicGetSeries (params?: {}): Promise<List>;
    gammaPublicGetSeriesSummarySlugSlug (params?: {}): Promise<Dict>;
    gammaPublicGetSeriesSummaryId (params?: {}): Promise<Dict>;
    gammaPublicGetSeriesId (params?: {}): Promise<Dict>;
    gammaPublicGetSeriesIdCommentsCount (params?: {}): Promise<Dict>;
    gammaPublicGetSports (params?: {}): Promise<List>;
    gammaPublicGetSportsMarketTypes (params?: {}): Promise<Dict>;
    gammaPublicGetTags (params?: {}): Promise<List>;
    gammaPublicGetTagsSlugSlug (params?: {}): Promise<Dict>;
    gammaPublicGetTagsSlugSlugRelatedTags (params?: {}): Promise<List>;
    gammaPublicGetTagsSlugSlugRelatedTagsTags (params?: {}): Promise<List>;
    gammaPublicGetTagsId (params?: {}): Promise<Dict>;
    gammaPublicGetTagsIdRelatedTags (params?: {}): Promise<List>;
    gammaPublicGetTagsIdRelatedTagsTags (params?: {}): Promise<List>;
    gammaPublicGetTeams (params?: {}): Promise<List>;
    gammaPublicGetTeamsId (params?: {}): Promise<Dict>;
    gammaPublicPostMarketsAbridged (params?: {}): Promise<List>;
    gammaPublicPostMarketsInformation (params?: {}): Promise<List>;
    clobPublicGetBook (params?: {}): Promise<Dict>;
    clobPublicGetBooks (params?: {}): Promise<List>;
    clobPublicGetBuilderTrades (params?: {}): Promise<Dict>;
    clobPublicGetClobMarketsConditionId (params?: {}): Promise<Dict>;
    clobPublicGetFeeRate (params?: {}): Promise<Dict>;
    clobPublicGetFeeRateTokenId (params?: {}): Promise<Dict>;
    clobPublicGetLastTradePrice (params?: {}): Promise<Dict>;
    clobPublicGetLastTradesPrices (params?: {}): Promise<List>;
    clobPublicGetMarketsByTokenTokenId (params?: {}): Promise<Dict>;
    clobPublicGetMarketsLiveActivityConditionId (params?: {}): Promise<Dict>;
    clobPublicGetMidpoint (params?: {}): Promise<Dict>;
    clobPublicGetMidpoints (params?: {}): Promise<Dict>;
    clobPublicGetNegRisk (params?: {}): Promise<Dict>;
    clobPublicGetNegRiskTokenId (params?: {}): Promise<Dict>;
    clobPublicGetPrice (params?: {}): Promise<Dict>;
    clobPublicGetPrices (params?: {}): Promise<Dict>;
    clobPublicGetPricesHistory (params?: {}): Promise<Dict>;
    clobPublicGetRebatesCurrent (params?: {}): Promise<List>;
    clobPublicGetRewardsMarketsCurrent (params?: {}): Promise<Dict>;
    clobPublicGetRewardsMarketsMulti (params?: {}): Promise<Dict>;
    clobPublicGetRewardsMarketsConditionId (params?: {}): Promise<Dict>;
    clobPublicGetSamplingMarkets (params?: {}): Promise<Dict>;
    clobPublicGetSamplingSimplifiedMarkets (params?: {}): Promise<Dict>;
    clobPublicGetSimplifiedMarkets (params?: {}): Promise<Dict>;
    clobPublicGetSpread (params?: {}): Promise<Dict>;
    clobPublicGetTickSize (params?: {}): Promise<Dict>;
    clobPublicGetTickSizeTokenId (params?: {}): Promise<Dict>;
    clobPublicGetTime (params?: {}): Promise<string>;
    clobPublicPostBatchPricesHistory (params?: {}): Promise<Dict>;
    clobPublicPostBooks (params?: {}): Promise<List>;
    clobPublicPostLastTradesPrices (params?: {}): Promise<List>;
    clobPublicPostMarketsLiveActivity (params?: {}): Promise<List>;
    clobPublicPostMidpoints (params?: {}): Promise<Dict>;
    clobPublicPostPrices (params?: {}): Promise<Dict>;
    clobPublicPostSpreads (params?: {}): Promise<Dict>;
    clobPrivateGetAuthApiKeys (params?: {}): Promise<Dict>;
    clobPrivateGetAuthBanStatusClosedOnly (params?: {}): Promise<Dict>;
    clobPrivateGetAuthBuilderApiKey (params?: {}): Promise<List>;
    clobPrivateGetAuthDeriveApiKey (params?: {}): Promise<Dict>;
    clobPrivateGetBalanceAllowance (params?: {}): Promise<Dict>;
    clobPrivateGetBalanceAllowanceUpdate (params?: {}): Promise<Dict>;
    clobPrivateGetDataOrderId (params?: {}): Promise<Dict>;
    clobPrivateGetDataOrders (params?: {}): Promise<Dict>;
    clobPrivateGetDataTrades (params?: {}): Promise<Dict>;
    clobPrivateGetNotifications (params?: {}): Promise<List>;
    clobPrivateGetOrderScoring (params?: {}): Promise<Dict>;
    clobPrivateGetOrdersScoring (params?: {}): Promise<Dict>;
    clobPrivateGetRewardsUser (params?: {}): Promise<Dict>;
    clobPrivateGetRewardsUserMarkets (params?: {}): Promise<Dict>;
    clobPrivateGetRewardsUserPercentages (params?: {}): Promise<Dict>;
    clobPrivateGetRewardsUserTotal (params?: {}): Promise<List>;
    clobPrivatePostAuthApiKey (params?: {}): Promise<Dict>;
    clobPrivatePostAuthBuilderApiKey (params?: {}): Promise<Dict>;
    clobPrivatePostHeartbeats (params?: {}): Promise<Dict>;
    clobPrivatePostOrder (params?: {}): Promise<Dict>;
    clobPrivatePostOrders (params?: {}): Promise<List>;
    clobPrivatePostV1Heartbeats (params?: {}): Promise<Dict>;
    clobPrivateDeleteAuthApiKey (params?: {}): Promise<string>;
    clobPrivateDeleteAuthBuilderApiKey (params?: {}): Promise<string>;
    clobPrivateDeleteCancelAll (params?: {}): Promise<Dict>;
    clobPrivateDeleteCancelMarketOrders (params?: {}): Promise<Dict>;
    clobPrivateDeleteNotifications (params?: {}): Promise<string>;
    clobPrivateDeleteOrder (params?: {}): Promise<Dict>;
    clobPrivateDeleteOrders (params?: {}): Promise<Dict>;
    dataPublicGetActivity (params?: {}): Promise<List>;
    dataPublicGetClosedPositions (params?: {}): Promise<List>;
    dataPublicGetHolders (params?: {}): Promise<List>;
    dataPublicGetLiveVolume (params?: {}): Promise<List>;
    dataPublicGetOi (params?: {}): Promise<List>;
    dataPublicGetOther (params?: {}): Promise<List>;
    dataPublicGetPositions (params?: {}): Promise<Dict>;
    dataPublicGetRevisions (params?: {}): Promise<List>;
    dataPublicGetTraded (params?: {}): Promise<Dict>;
    dataPublicGetTrades (params?: {}): Promise<List>;
    dataPublicGetV1AccountingSnapshot (params?: {}): Promise<Dict>;
    dataPublicGetV1ActivityCombos (params?: {}): Promise<Dict>;
    dataPublicGetV1BuildersLeaderboard (params?: {}): Promise<List>;
    dataPublicGetV1BuildersVolume (params?: {}): Promise<List>;
    dataPublicGetV1Leaderboard (params?: {}): Promise<List>;
    dataPublicGetV1MarketPositions (params?: {}): Promise<List>;
    dataPublicGetV1PositionsCombos (params?: {}): Promise<Dict>;
    dataPublicGetValue (params?: {}): Promise<List>;
    combosPublicGetV1RfqComboMarkets (params?: {}): Promise<Dict>;
    combosPrivatePostV1MakerConfirmations (params?: {}): Promise<Dict>;
    combosPrivatePostV1MakerQuotes (params?: {}): Promise<Dict>;
    combosPrivatePostV1MakerQuotesCancel (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
